import { PostHogProvider, usePostHog } from "posthog-js/react"
import { PropsWithChildren, useEffect } from "react"
import { useViewer } from "../api/viewer/useViewer"

export const PosthogClient = ({ children }: PropsWithChildren<{}>) => {
  const [viewerState] = useViewer({})
  const viewerLoading = viewerState.loading
  const viewer = viewerState.result?.data
  const posthog = usePostHog()

  useEffect(() => {
    if (!viewerLoading && viewer && posthog) {
      posthog?.identify(viewer.id, {
        email: viewer.email,
        name: viewer.name,
      })
      // Using viewerKind (instead of viewerType) as the name of this as that's what
      // it is caled in the Platform Frontend codebase which we're moving towards.
      posthog?.group(`viewerKind`, viewer.type)
    }
  }, [viewerLoading, viewer?.id, viewer?.email, viewer?.name, viewer?.type, posthog])

  const posthogPublicKey = process.env.REACT_APP_PUBLIC_POSTHOG_KEY || ``
  const options = {
    api_host: `https://eu.i.posthog.com`,
    debug: process.env.APP_ENV !== `prod`,
  }

  return (
    <PostHogProvider apiKey={posthogPublicKey} options={options}>
      {children}
    </PostHogProvider>
  )
}
